"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsrMessageType = void 0;
var AsrMessageType;
(function (AsrMessageType) {
    AsrMessageType["SET_CONFIG"] = "set_config";
    AsrMessageType["SET_GRAMMAR"] = "set_grammar";
    AsrMessageType["SET_PROMPT"] = "set_prompt";
    AsrMessageType["GET_RESULT"] = "get_result";
    AsrMessageType["PING"] = "ping";
    AsrMessageType["PONG"] = "pong";
    AsrMessageType["GET_FSM_STATE"] = "get_fsm_state";
    AsrMessageType["SET_ACCESS_TOKEN"] = "set_access_token";
    AsrMessageType["INTERMEDIATE_RESULT"] = "intermediate_result";
})(AsrMessageType = exports.AsrMessageType || (exports.AsrMessageType = {}));
//# sourceMappingURL=asr-message-type.js.map